/**
 * handle Dropdown
 */
const handleDropdown = () => {
	const $dropdownTrigger = $('.dropdown .dropdown__trigger');

	$dropdownTrigger.on('click', function(event) {
		const $this = $(this);

		$this.closest('.dropdown').toggleClass('is-active');

		event.preventDefault();
	});
}

handleDropdown();
